import React from 'react'


import {ChapterTen} from './Containers/Content/10.js';
import {ChapterEleven} from './Containers/Content/11.js';
import {ChapterTwelve} from './Containers/Content/12.js';


import {ChapterTwenty} from './Containers/Content/20.js';
import {ChapterTwentyOne} from './Containers/Content/21.js';
import {ChapterTwentyTwo} from './Containers/Content/22.js';
import {ChapterTwentyThree} from './Containers/Content/23.js';
import {ChapterTwentyFour} from './Containers/Content/24.js';

import {ChapterThirty} from './Containers/Content/30.js';
import {ChapterThirtyOne} from './Containers/Content/31.js';


import {ChapterForty} from './Containers/Content/40.js';
import {ChapterFortyOne} from './Containers/Content/41.js';
import {ChapterFortyTwo} from './Containers/Content/42.js';
import {ChapterFortyThree} from './Containers/Content/43.js';

import {ChapterFifty} from './Containers/Content/50.js';
import {ChapterFiftyOne} from './Containers/Content/51.js';
import {ChapterFiftyTwo} from './Containers/Content/52.js';
import {ChapterFiftyThree} from './Containers/Content/53.js';
import {ChapterFiftyFour} from './Containers/Content/54.js';
import {ChapterFiftyFive} from './Containers/Content/55.js';

import {ChapterSixty} from './Containers/Content/60.js';
import {ChapterSixtyOne} from './Containers/Content/61.js';
import {ChapterSixtyTwo} from './Containers/Content/62.js';

import {ChapterSeventy} from './Containers/Content/70.js';
import {ChapterSeventyOne} from './Containers/Content/71.js';

import {ChapterEighty} from './Containers/Content/80.js';
import {ChapterEightyOne} from './Containers/Content/81.js';
import {ChapterEightyTwo} from './Containers/Content/82.js';


import {ChapterNinety} from './Containers/Content/90.js';
import {ChapterNinetyOne} from './Containers/Content/91.js';
import {ChapterNinetyTwo} from './Containers/Content/92.js';
import {ChapterNinetyThree} from './Containers/Content/93.js';


import {ChapterHundred} from './Containers/Content/100.js';


import {ChapterHundredTen} from './Containers/Content/110.js';
import {ChapterHundredEleven} from './Containers/Content/111.js';
import {ChapterHundredTwelve} from './Containers/Content/112.js';
import {ChapterHundredThirteen} from './Containers/Content/113.js';
import {ChapterHundredFourteen} from './Containers/Content/114.js';
import {ChapterHundredFifteen} from './Containers/Content/115.js';
import {ChapterHundredSixteen} from './Containers/Content/116.js';

import {ChapterHundredTwenty} from './Containers/Content/120.js';
import {ChapterHundredTwentyOne} from './Containers/Content/121.js';
import {ChapterHundredTwentyTwo} from './Containers/Content/122.js';


const topics = [
{
  name: 'Introduction',
  number: 1,
  id: 'introduction',
  next:"/topics/evolving-sea",
  buttonText:"Next Chapter",
  submenuName: 'introduction',
  content: <ChapterTen topicNumber="01" topicTitle="Introduction" topicText=""  nextChapter="/topics/introduction/a-word-from-monks-hill-ventures" next="/topics/evolving-sea" buttonText="Next Chapter" />,

  resources: [
    {
      name: "A word from Monk's Hill Ventures",
      id: 'a-word-from-monks-hill-ventures',
      subnumber: 1.1,
      content: <ChapterEleven number="1.1" name="A word from Monk's Hill Ventures" next="/topics/introduction/a-word-from-slush-singapore" buttonText="Next article" />

    },
    {
      name: 'A word from Slush Singapore',
      id: 'a-word-from-slush-singapore',
      subnumber: 1.2,
      content: <ChapterTwelve number="1.2" name="A word from Slush" next="/topics/evolving-sea"  buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Evolving SEA',
  number: 2,
  id: 'evolving-sea',
  next:"/topics/ecosystem-trends",
  buttonText:"Next Chapter",
  submenuName: 'evolving sea',
  content: <ChapterTwenty topicNumber="02" topicTitle="Evolving Southeast Asia" nextChapter="/topics/evolving-sea/its-been-a-big-year-for-Southeast-Asian-tech" next="/topics/ecosystem-trends" buttonText="Next article"/>,

  resources: [
    {
      name: 'It’s been a big year for Southeast Asian tech',
      id: 'its-been-a-big-year-for-Southeast-Asian-tech',
      subnumber: 2.1,
      content: <ChapterTwentyOne number="2.1" name="It’s been a big year for Southeast Asian tech" next="/topics/evolving-sea/the-number-of-exits-each-year-continues-to-grow" buttonText="Next article" />

    },
    {
      name: 'The number of exits each year continues to grow',
      id: 'the-number-of-exits-each-year-continues-to-grow',
      subnumber: 2.2,
      content: <ChapterTwentyTwo number="2.2" name="The number of exits each year continues to grow" next="/topics/evolving-sea/southeast-asian-unicorns-thrive" buttonText="Next article" />

    },

    {
      name: 'Southeast Asian unicorns thrive',
      id: 'southeast-asian-unicorns-thrive',
      subnumber: 2.3,
      content: <ChapterTwentyThree number="2.3" name="Southeast Asian unicorns thrive" next="/topics/evolving-sea/optimism-for-the-tech-startup-ecosystem" buttonText="Next article" />

    }
    ,

    {
      name: 'Optimism for the tech startup ecosystem',
      id: 'optimism-for-the-tech-startup-ecosystem',
      subnumber: 2.4,
      content: <ChapterTwentyFour number="2.4" name="Optimism for the tech startup ecosystem" next="/topics/ecosystem-trends" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Ecosystem trends',
  number: 3,
  id: 'ecosystem-trends',
  next:"/topics/capital-flows",
  buttonText:"Next Chapter",
  submenuName: 'ecosystem trends',
  content: <ChapterThirty topicNumber="03" topicTitle="Ecosystem trends" topicText="" nextChapter="/topics/ecosystem-trends/geographical-integration-is-growing" next="/topics/talent" buttonText="Next article"/>,

  resources: [
    {
      name: 'Geographical integration is growing',
      id: 'geographical-integration-is-growing',
      subnumber: 3.1,
      content: <ChapterThirtyOne number="3.1" name="Geographical integration is growing" next="/topics/capital-flows" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Capital Flows',
  number: 4,
  id: 'capital-flows',
  next:"/topics/talent",
  buttonText:"Next Chapter",
  submenuName: 'capital flows',
  content: <ChapterForty topicNumber="04" topicTitle="Capital Flows" nextChapter="/topics/capital-flows/the-late-stage-funding-gap" next="/topics/regulations" buttonText="Next article"/>,

  resources: [
    {
      name: 'The late stage funding gap',
      id: 'the-late-stage-funding-gap',
      subnumber: 4.1,
      content: <ChapterFortyOne number="4.1" name="The late stage funding gap" next="/topics/capital-flows/most-funding-dollars-flow-into-a-few-tech-hubs" buttonText="Next article" />

    },
    {
      name: 'Most funding dollars flow into a few tech hubs',
      id: 'most-funding-dollars-flow-into-a-few-tech-hubs',
      subnumber: 4.2,
      content: <ChapterFortyTwo number="4.2" name="Most funding dollars flow into a few tech hubs" next="/topics/capital-flows/logistics-and-ecommerce-are-king" buttonText="Next article" />

    },
    {
      name: 'Logistics and ecommerce are king',
      id: 'logistics-and-ecommerce-are-king',
      subnumber: 4.3,
      content: <ChapterFortyThree number="4.3" name="Logistics and ecommerce are king" next="/topics/talent" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Talent',
  number: 5,
  id: 'talent',
  next:"/topics/founder-portrait",
  buttonText:"Next Chapter",
  submenuName: 'talent',
  content: <ChapterFifty topicNumber="05" topicTitle="Talent"  nextChapter="/topics/talent/talent-needs-are-top-of-mind" next="/topics/community" buttonText="Next article"/>,

  resources: [
    {
      name: 'Talent needs are top of mind',
      id: 'talent-needs-are-top-of-mind',
      subnumber: 5.1,
      content: <ChapterFiftyOne number="5.1" name="Talent needs are top of mind" next="/topics/talent/the-software-development-skills-gap-is-still-a-key-concern" buttonText="Next article" />

    },
    {
      name: 'The software development skills gap is still a key concern',
      id: 'the-software-development-skills-gap-is-still-a-key-concern',
      subnumber: 5.2,
      content: <ChapterFiftyTwo number="5.2" name="The software development skills gap is still a key concern" next="/topics/talent/singapore-offers-the-strongest-tech-employment-opportunities" buttonText="Next article" />

    },
    {
      name: 'Singapore offers the strongest tech employment opportunities',
      id: 'singapore-offers-the-strongest-tech-employment-opportunities',
      subnumber: 5.3,
      content: <ChapterFiftyThree number="5.3" name="Singapore offers the strongest tech employment opportunities" next="/topics/talent/views-on-gender-diversity-are-mixed" buttonText="Next Article" />

    },
    {
      name: 'Views on gender diversity are mixed',
      id: 'views-on-gender-diversity-are-mixed',
      subnumber: 5.4,
      content: <ChapterFiftyFour number="5.4" name="Views on gender diversity are mixed" next="/topics/talent/southeast-asian-tech-is-ethnically-diverse" buttonText="Next Article" />

    },
    {
      name: 'Southeast Asian tech is ethnically diverse',
      id: 'southeast-asian-tech-is-ethnically-diverse',
      subnumber: 5.5,
      content: <ChapterFiftyFive number="5.5" name="Southeast Asian tech is ethnically diverse" next="/topics/founder-portrait" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Portrait of a SEA founder',
  number: 6,
  id: 'founder-portrait',
  next:"/topics/community",
  buttonText:"Next Chapter",
  submenuName: 'founder portrait',
  content: <ChapterSixty topicNumber="06" topicTitle="Portrait of a Southeast Asian founder" nextChapter="/topics/founder-portrait/key-insights-from-founder-survey" next="/topics/community" buttonText="Next article"/>,

  resources: [
    {
      name: 'Key insights from founder survey',
      id: 'key-insights-from-founder-survey',
      subnumber: 6.1,
      content: <ChapterSixtyOne number="6.1" name="Key insights from founder survey" next="/topics/founder-portrait/the-role-of-sea-turtles" buttonText="Next Chapter" />

    },
    {
      name: 'The role of “Sea Turtles”',
      id: 'the-role-of-sea-turtles',
      subnumber: 6.2,
      content: <ChapterSixtyTwo number="6.2" name="The role of “Sea Turtles”" next="/topics/community" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Community',
  number: 7,
  id: 'community',
  next:"/topics/capital-flows",
  buttonText:"Next Chapter",
  submenuName: 'community',
  content: <ChapterSeventy topicNumber="07" topicTitle="Community" nextChapter="/topics/community/singapore-remains-a-popular-home-base" buttonText="Next Article"/>,

  resources: [
    {
      name: 'Singapore remains a popular home base',
      id: 'singapore-remains-a-popular-home-base',
      subnumber: 7.1,
      content: <ChapterSeventyOne number="7.1" name="Singapore remains a popular home base" next="/topics/regulations" buttonText="Next Chapter" />

    }
  ]
},

{
  name: 'Regulations & Government ',
  number: 8,
  id: 'regulations',
  next:"/topics/whats-next",
  buttonText:"Next Chapter",
  submenuName: 'regulations',
  content: <ChapterEighty topicNumber="08" topicTitle="Regulations & Government Incentives"  nextChapter="/topics/regulations/most-startups-receive-no-government-support" next="/topics/welcome" buttonText="Next article"/>,

  resources: [
    {
      name: 'Most startups receive no government support',
      id: 'most-startups-receive-no-government-support',
      subnumber: 8.1,
      content: <ChapterEightyOne number="8.1" name="Most startups receive no government support" next="/topics/regulations/regulation-is-not-an-impediment-to-growth" buttonText="Next Article" />

    },
    {
      name: 'Regulation is not an impediment to growth',
      id: 'regulation-is-not-an-impediment-to-growth',
      subnumber: 8.2,
      content: <ChapterEightyTwo number="8.2" name="Regulation is not an impediment to growth" next="/topics/whats-next" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'What’s Next',
  number: 9,
  id: 'whats-next',
  next:"/topics/welcome",
  buttonText:"Next Chapter",
  submenuName: 'whats next',
  content: <ChapterNinety topicNumber="09" topicTitle="What’s Next"  nextChapter="/topics/whats-next/crypto-on-the-rise" next="/topics/glossary" buttonText="Next article"/>,

  resources: [
    {
      name: 'Crypto on the rise',
      id: 'crypto-on-the-rise',
      subnumber: 9.1,
      content: <ChapterNinetyOne number="9.1" name="Crypto on the rise" next="/topics/whats-next/more-unicorns-to-come" buttonText="Next article" />

    },
    {
      name: 'More unicorns to come ',
      id: 'more-unicorns-to-come',
      subnumber: 9.2,
      content: <ChapterNinetyTwo number="9.2" name="More unicorns to come " next="/topics/whats-next/chinas-role-remains-in-flux" buttonText="Next Article" />

    },
    {
      name: 'China’s role remains in flux',
      id: 'chinas-role-remains-in-flux',
      subnumber: 9.3,
      content: <ChapterNinetyThree number="9.3" name="China’s role remains in flux" next="/topics/glossary" buttonText="Next Chapter" />

    }
  ]
},
{
  name: 'Glossary',
  number: 10,
  id: 'glossary',
  next:"/topics/acknowledgements",
  buttonText:"Next Chapter",
  submenuName: 'glossary',
  content: <ChapterHundred topicNumber="10" topicTitle="Glossary"  nextChapter="/topics/acknowledgements" next="/topics/acknowledgements" buttonText="Next article"/>,

  resources: [

  ]
},
{
  name: 'Acknowledgements',
  number: 11,
  id: 'acknowledgements',
  next:"/topics/welcome",
  buttonText:"Next Chapter",
  submenuName: 'acknowledgements',
  content: <ChapterHundredTen topicNumber="11" topicTitle="Acknowledgements"  nextChapter="/topics/acknowledgements/about-monks-hill-ventures" next="/topics/welcome" buttonText="Next article"/>,

  resources: [
    {
      name: 'About Monk’s Hill Ventures',
      id: 'about-monks-hill-ventures',
      subnumber: 11.1,
      content: <ChapterHundredEleven number="11.1" name="About Monk’s Hill Ventures" next="/topics/acknowledgements/about-slush-singapore"  buttonText="Next Article" />

    },
    {
      name: 'About Slush Singapore',
      id: 'about-slush-singapore',
      subnumber: 11.2,
      content: <ChapterHundredTwelve number="11.2" name="About Slush Singapore" next="/topics/acknowledgements/interviewees"  buttonText="Next Article" />

    },
    {
      name: 'Interviewees',
      id: 'interviewees',
      subnumber: 11.3,
      content: <ChapterHundredThirteen number="11.3" name="Interviewees" next="/topics/acknowledgements/content-partners"  buttonText="Next Article" />

    },
    {
      name: 'Content Partners',
      id: 'content-partners',
      subnumber: 11.4,
      content: <ChapterHundredFourteen number="11.4" name="Content Partners" next="/topics/acknowledgements/data-partners"  buttonText="Next Chapter" />

    },
    {
      name: 'Data Partners',
      id: 'data-partners',
      subnumber: 11.5,
      content: <ChapterHundredFifteen number="11.5" name="Data Partners" next="/topics/acknowledgements/distribution-partners"  buttonText="Next Article" />

    },
    {
      name: 'Distribution Partners',
      id: 'distribution-partners',
      subnumber: 11.6,
      content: <ChapterHundredSixteen number="11.6" name="Distribution Partners" next="/topics/appendix"  buttonText="Next Chapter" />

    }
  ]
},{
  name: 'Appendix',
  number: 12,
  id: 'appendix',
  next:"/topics/acknowledgements",
  buttonText:"Next Chapter",
  submenuName: 'appendix',
  content: <ChapterHundredTwenty topicNumber="12" topicTitle="Appendix"  nextChapter="/topics/appendix/accelerators" next="/topics/appendix/accelerators" buttonText="Next Chapter"/>,

  resources: [
    {
      name: 'Accelerators',
      id: 'accelerators',
      subnumber: 12.1,
      content: <ChapterHundredTwentyOne number="12.1" name="Distribution Partners" next="/topics/appendix/co-working-spaces"  buttonText="Next Article" />

    },
    {
      name: 'Co-working spaces',
      id: 'co-working-spaces',
      subnumber: 12.2,
      content: <ChapterHundredTwentyTwo number="12.2" name="Co-working spaces" next="/topics/introduction"  buttonText="Next Chapter" />

    }

  ]
}


]

export default topics



// WEBPACK FOOTER //
// ./src/topics.js